/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetLivestockAttentionQueryResponse, GetLivestockAttentionPathParams, GetLivestockAttentionQueryParams, GetLivestockAttention400, GetLivestockAttention401, GetLivestockAttention403, GetLivestockAttention404, GetLivestockAttention409, GetLivestockAttention500 } from "../../types/livestockController/GetLivestockAttention.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLivestockAttention } from "../../client/livestockController/getLivestockAttention.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLivestockAttentionQueryKey = (organizationId: GetLivestockAttentionPathParams["organizationId"] | undefined, params?: GetLivestockAttentionQueryParams) => [{ url: '/api/organizations/:organizationId/livestock-attention', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetLivestockAttentionQueryKey = ReturnType<typeof getLivestockAttentionQueryKey>

export function getLivestockAttentionQueryOptions(organizationId: GetLivestockAttentionPathParams["organizationId"] | undefined, params?: GetLivestockAttentionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLivestockAttentionQueryKey(organizationId, params)
        return queryOptions<GetLivestockAttentionQueryResponse, ResponseErrorConfig<GetLivestockAttention400 | GetLivestockAttention401 | GetLivestockAttention403 | GetLivestockAttention404 | GetLivestockAttention409 | GetLivestockAttention500>, GetLivestockAttentionQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLivestockAttention(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Computed 'needs attention' alerts (vaccination due, weighing overdue, paddock overstay, over capacity, calving window)
 * {@link /api/organizations/:organizationId/livestock-attention}
 */
export function useGetLivestockAttention<TData = GetLivestockAttentionQueryResponse, TQueryData = GetLivestockAttentionQueryResponse, TQueryKey extends QueryKey = GetLivestockAttentionQueryKey>(organizationId: GetLivestockAttentionPathParams["organizationId"] | undefined, params?: GetLivestockAttentionQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetLivestockAttentionQueryResponse, ResponseErrorConfig<GetLivestockAttention400 | GetLivestockAttention401 | GetLivestockAttention403 | GetLivestockAttention404 | GetLivestockAttention409 | GetLivestockAttention500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLivestockAttentionQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getLivestockAttentionQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLivestockAttention400 | GetLivestockAttention401 | GetLivestockAttention403 | GetLivestockAttention404 | GetLivestockAttention409 | GetLivestockAttention500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}